export default __webpack_public_path__ + "static/media/yura.dc1bf4ec.jfif";